import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";
import { showToast } from "../components/ui/toast";

export const useGetCostBreakdownQuery = (params, enabled = true) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ["costBreakdown", params],
    queryFn: () => api.get(API_ROUTES.GET_COST_BREAKDOWN, { params }),
    enabled,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useGetProductEconomicsQuery = (params, enabled = true) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ["productEconomics", params],
    queryFn: () => api.get(API_ROUTES.GET_PRODUCT_ECONOMICS, { params }),
    enabled,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useGetProductTagsQuery = (params, enabled = true) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ["productTags", params],
    queryFn: () => api.get(API_ROUTES.GET_PRODUCT_TAGS, { params }),
    enabled,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};

export const useCreateProductTagMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post(API_ROUTES.CREATE_PRODUCT_TAG, data),
    onSuccess: () => {
      showToast("success", "Tag saved");
      queryClient.invalidateQueries({ queryKey: ["productTags"] });
      queryClient.invalidateQueries({ queryKey: ["productEconomics"] });
    },
    onError: () => showToast("error", "Failed to save tag"),
  });
};

export const useUpdateProductTagMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }) =>
      api.put(`${API_ROUTES.UPDATE_PRODUCT_TAG}/${id}`, data),
    onSuccess: () => {
      showToast("success", "Tag updated");
      queryClient.invalidateQueries({ queryKey: ["productTags"] });
      queryClient.invalidateQueries({ queryKey: ["productEconomics"] });
    },
    onError: () => showToast("error", "Failed to update tag"),
  });
};

export const useDeleteProductTagMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      api.delete(API_ROUTES.DELETE_PRODUCT_TAG, { data }),
    onSuccess: () => {
      showToast("success", "Tag removed");
      queryClient.invalidateQueries({ queryKey: ["productTags"] });
      queryClient.invalidateQueries({ queryKey: ["productEconomics"] });
    },
    onError: () => showToast("error", "Failed to remove tag"),
  });
};
